import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { FieldTypeResponseData } from "../../types/field-type";
import { queryKeys } from "../../query";

const fetchFieldType = async (id: string): Promise<FieldTypeResponseData> => {
  const { data } = await createApiWithPath("crm").get(`/field-types/${id}`);
  return data;
};

export const useFieldType = (id: string | undefined) => {
  return useQuery(queryKeys.fieldType(id), () => fetchFieldType(id!), {
    enabled: !!id,
  });
};
